import React, { ReactNode, useContext, useEffect, useState } from 'react';

import ServiceContext from '@totem/components/devices/services/serviceContext';
import { DeviceService } from '@totem/components/devices/services/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  id: string;
  children?: ReactNode;
};

const ServiceContainer = ({ id, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<DeviceService[]>([]);
  const [action, setAction] = useState<string>('');
  const [actionItem, setActionItem] = useState<DeviceService>(null);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);

      const uri = `${DEVICES_ENDPOINT}/${id}/services`;

      fetch(uri, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: DeviceService[]) => {
          setData(result);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [id, refreshData, getApiToken]);

  const handleAction = (newAction: string, item: DeviceService) => {
    switch (newAction) {
      default:
        setAction(newAction);

        setActionItem(item);
    }
  };

  return (
    <ServiceContext.Provider
      value={{
        deviceId: id,
        loading: isLoading,
        data,
        action,
        actionItem,
        onAction: handleAction,
      }}
    >
      <div>{children}</div>
    </ServiceContext.Provider>
  );
};

export default ServiceContainer;
